import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { withTranslation } from "react-i18next"
import Breadcrumbs from "components/Common/Breadcrumb"
import PartnerCockpitList from "./PartnerCockpitList"
import { Link } from "react-router-dom"
import { IsPartnerCockpitModuleEnabled } from "helpers/misc_helpers"
import { useLoading } from "helpers/custom_hooks"

const PartnerCockpit = props => {
  const setLoading = useLoading()
  const [partnerCockpitEnabled, setPartnerCockpitEnabled] = useState(false)

  const loadPermissions = async _ => {
    setLoading(true)
    const isEnabled = await IsPartnerCockpitModuleEnabled()
    setPartnerCockpitEnabled(isEnabled)
    setLoading(false)
  }

  useEffect(() => {
    loadPermissions()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {partnerCockpitEnabled ? (
            <>
              <Breadcrumbs
                title={props.t("Partner Cockpit")}
                breadcrumbItem={props.t("Overview")}
              />

              <Row>
                <Col lg="12">
                  <PartnerCockpitList />
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              <Col lg="12">
                <div className="text-center mb-5">
                  <h1 className="display-2 fw-medium">
                    4<i className="bx bx-buoy bx-spin text-primary display-3" />
                    3
                  </h1>
                  <h4 className="text-uppercase">
                    Sorry, you are not allowed to view this page
                  </h4>
                  <p className="text-primary">
                    This is a premium feature. To use this feature, please
                    upgrade your license!
                  </p>
                  <div className="mt-5 text-center">
                    <Link
                      className="btn btn-primary waves-effect waves-light "
                      to="/settings?tab=2"
                    >
                      Upgrade Account
                    </Link>
                    <br />
                    <Link className=" d-block mt-4" to="/dashboard">
                      <i className="bx bx-left-arrow-alt" />
                      Back to Dashboard
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(PartnerCockpit)
